
import { Carousel } from '@/components/cells'
import { CategoryCard } from '@/components/organisms'
import { getTranslate } from '@/tolgee/server'

const categoryHandles = [
  'sneakers',
  'sandals',
  'boots',
  'sport',
  'accessories',
]

export async function HomeCategories({ heading }: { heading: string }) {
  const t = await getTranslate()

  const categories = categoryHandles.map((handle, index) => ({
    id: index + 1,
    name: t(`category_handle.${handle}`),
    handle,
  }))

  return (
    <section className="bg-primary py-8 w-full">
      <div className="mb-6">
        <h2 className="heading-lg text-primary uppercase">{heading}</h2>
      </div>
      <Carousel
        items={categories.map((category) => (
          <CategoryCard key={category.id} category={category} />
        ))}
      />
    </section>
  )
}
